module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ja-社会责任.74aafe88.png";